import { useCountdownTimer } from 'infrastructure/hooks/use-count-down-timer';

import type { FC } from 'react';

export type CountdownTimerProps = {
  endTime: Date;
  onFinish?: () => void;
  className?: string;
  isNegative?: boolean;
};

const CountdownTimer: FC<CountdownTimerProps> = ({
  endTime,
  onFinish,
  className,
  isNegative,
}) => {
  const duration = useCountdownTimer({ endTime, onFinish });

  const formatUnit = (v = 0) => String(v).padStart(2, '0');

  const hoursUnit = formatUnit(duration?.hours);
  const minutesUnit = formatUnit(duration?.minutes);
  const secondsUnit = formatUnit(duration?.seconds);

  const prefix = isNegative ? '-' : '';

  const timeStr = `${prefix}${hoursUnit}:${minutesUnit}:${secondsUnit}`;

  return <span className={className}>{timeStr}</span>;
};

export default CountdownTimer;
